import { allow } from '../classes/allow';
import local from '../classes/local';
import is from '../objects/is';
import translation from '../smartling/translations';

export default function translate(english = '', replacements = {}, translateTo = '') {
   const replace = (text = '', replacements = {}) => {
      allow.aString(text, is.not.empty).anObject(replacements);
      let replacedText = text;
      Object.entries(replacements).forEach(entry => {
         const [target, replacement] = entry;
         const pieces = replacedText.split(`{{${target}}}`);
         replacedText = pieces.join(replacement.toString());
      });
      return replacedText.toString();
   };
   
   allow.aString(english, is.not.empty).anObject(replacements).aString(translateTo);
   const language = translateTo || local.getItem('language') || 'English';
   if (language === 'English') {
      if (!translation['Spanish'][english])
         console.warn(`No translation available for [${english}]`);
      return replace(english, replacements).toString();
   }
   const spanish = translation[language][english];
   if (!spanish) {
      console.warn(`No translation available for [${english}]`);
      return replace(english, replacements).toString();
   }
   return replace(spanish, replacements).toString();
};